import { graphql } from '@api/generated';

export const GET_TENANT_FEATURE_GATES = graphql(`
  query getTenantFeatureGates($where: TenantFeatureGatesInput) {
    tenantFeatureGates(where: $where) {
      key
      tenant {
        id
        name
      }
      value {
        ... on StringFeatureGate {
          stringValue: value
        }
        ... on NumberFeatureGate {
          numberValue: value
        }
        ... on BoolFeatureGate {
          boolValue: value
        }
        ... on ListOfStringsFeatureGate {
          listValue: value
        }
      }
    }
  }
`);
